/**
 * Přidání doplňku z pásu DOPORUČUJEME pod položkou košíku.
 *
 * Košík se obnovuje stejnou cestou jako rychlé přidání z kolekcí: událostí
 * `cart:update` na documentu, kterou si téma odchytí samo a překreslí drawer
 * i stránku košíku. Po překreslení se pás vyrenderuje znovu a právě přidaný
 * produkt z něj zmizí, protože už je v košíku.
 */
(function () {
  'use strict';

  // Snippet se posílá i při section renderingu, takže se script tag může
  // vyhodnotit vícekrát — bez téhle pojistky by se listener navrstvil.
  if (window.oqCartUpsellInit) return;
  window.oqCartUpsellInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest ? event.target.closest('.oq-iu__add') : null;
      if (!btn || btn.disabled) return;

      // Pás sedí uvnitř <form id="cart-form">; type="button" sice submit
      // nespustí, ale drawer má na klik delegované vlastní handlery.
      event.preventDefault();
      event.stopPropagation();

      var id = Number(btn.dataset.variantId);
      if (!id) return;

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add ' + res.status);
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'oq-item-upsell',
                data: { source: 'oq-item-upsell', itemCount: cart.item_count },
              },
            })
          );
        })
        .catch(function () {
          btn.classList.add('is-error');
          setTimeout(function () {
            btn.classList.remove('is-error');
          }, 1600);
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    },
    true
  );
})();
